export default __webpack_public_path__ + "static/media/section1_tool1.742bd91b.png";